import { Tab } from '@headlessui/react';

export { Tab };
